import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "./Address";
import getBusinessName from "../common/Business";
import getPersonName from "../common/Name";
import { getDate } from "../common/DisplayDate";

const getLiensOrJudgementsDetail = (props, record, index) => {
  const rows = [];
  const hasFilingType = _.get(record, "filingType[0]._", "") !== "";
  const hasCourt = _.get(record, "court[0].businessName[0]._", "") !== "";
  const businessName = _.get(record, "businessName[0]._", "");
  let plaintiff = _.get(record, "plaintiff[0].name[0].businessName[0]._", "");
  if (plaintiff === "") {
    plaintiff = `${_.get(
      record,
      "plaintiffName[0].firstName[0]._",
      ""
    )} ${_.get(record, "plaintiffName[0].lastName[0]._", "")}`;
  }
  const filingDate = getDate(_.get(record, "filingDate[0]"));
  rows.push(
    <Table.Row
      key={`rep_liens_row_1_${index}`}
      className={`${index % 2 === 1 ? "table-row-odd-child" : ""}`}
    >
      <Table.Cell className="text-bold" width={2}>
        {businessName !== "" ? "Business Name:" : "Name:"}
      </Table.Cell>
      <Table.Cell width={4}>
        {businessName !== ""
          ? getBusinessName(businessName, props)
          : getPersonName(
              _.get(record, "name[0].firstName[0]._", ""),
              _.get(record, "name[0].middleName[0]._", ""),
              _.get(record, "name[0].lastName[0]._", ""),
              props
            )}
      </Table.Cell>
      <Table.Cell className="text-bold" width={2}>
        {hasFilingType ? "Filing Type:" : "Deed Category:"}
      </Table.Cell>
      <Table.Cell width={2}>
        {hasFilingType
          ? _.get(record, "filingType[0]._", "")
          : _.get(record, "deedCategoryType[0]._", "")}
      </Table.Cell>
      <Table.Cell className="text-bold" width={2}>
        Plaintiff:
      </Table.Cell>
      <Table.Cell width={4}>{plaintiff}</Table.Cell>
    </Table.Row>
  );
  rows.push(
    <Table.Row
      key={`rep_liens_row_2_${index}`}
      className={`${index % 2 === 1 ? "table-row-odd-child" : ""}`}
    >
      <Table.Cell className="text-bold" width={2}>
        Address:
      </Table.Cell>
      <Table.Cell width={4}>
        <Address addressNode={record.address[0]} {...props} />
      </Table.Cell>
      <Table.Cell className="text-bold" width={2}>
        {hasFilingType ? "Case Number:" : "Document Type:"}
      </Table.Cell>
      <Table.Cell width={2}>
        {hasFilingType
          ? _.get(record, "courtCaseNumber[0]._", "")
          : _.get(record, "deedCategoryType[0]._", "")}
      </Table.Cell>
      <Table.Cell className="text-bold" width={2}>
        {hasFilingType ? "Court:" : "Filed At:"}
      </Table.Cell>
      <Table.Cell width={4}>
        {hasFilingType
          ? _.get(record, "court[0].businessName[0]._", "")
          : _.get(record, "filingLocation[0]._", "")}
      </Table.Cell>
    </Table.Row>
  );
  rows.push(
    <Table.Row
      key={`rep_liens_row_3_${index}`}
      className={`${index % 2 === 1 ? "table-row-odd-child" : ""}`}
    >
      <Table.Cell className="text-bold" width={2}>
        {hasCourt ? "Court:" : "Filing Location:"}
      </Table.Cell>
      <Table.Cell width={4}>
        {hasCourt
          ? _.get(record, "court[0].businessName[0]._", "")
          : _.get(record, "filingLocation[0]._", "")}
      </Table.Cell>
      <Table.Cell className="text-bold" width={2}>
        Filing Date:
      </Table.Cell>
      <Table.Cell width={2}>{filingDate === "//" ? "" : filingDate}</Table.Cell>
      <Table.Cell className="text-bold" width={2}>
        {hasFilingType ? "Court Location:" : "Document Type:"}
      </Table.Cell>
      <Table.Cell width={4}>
        {hasFilingType
          ? `${_.get(record, "court[0].address[0].city[0]._", "")}, ${_.get(
              record,
              "court[0].address[0].state[0]._",
              ""
            )}`
          : _.get(record, "damarDocumentType[0]._", "")}
      </Table.Cell>
    </Table.Row>
  );
  return (
    <Table key={`Liens_Table_${index}`} className={`sub-table`}>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};

export default getLiensOrJudgementsDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/LiensJudgementsDetail.js